import { Injectable } from "@angular/core";
import {HttpClient,HttpHeaders} from "@angular/common/http"
import { ConfigService } from "../shared/utils/config.service";
import { map } from "rxjs";


@Injectable()
export class CountService {

    baseUrl: string = '';

    constructor(private http: HttpClient, private configService: ConfigService) {
        this.baseUrl = configService.getApiURI();
    };

    getCount() {
        return this.http.get(this.baseUrl + '/count')
            .pipe(
                map((res: any) => {
                    console.log(res, 'res count');
                    return res; // Return the value here
                })
            );
    }
}